import React from "react";
import { ErrorMessage, useField, Field } from "formik";
import FieldError from "./FieldError";
const TextField = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      {label && <label>{label}</label>}
      <Field type="input" className="default" name={props.name} {...field} {...props} />
      {meta.touched && meta.error && (
        <span id="error">
          <FieldError error={meta.error} />
        </span>
      )}
      {props.children && props.children}
    </>
  );
};

export default TextField;
